import styled from 'styled-components';
import {
  backgroundImage,
  backgroundSize,
  backgroundPosition,
  backgroundRepeat,
  BackgroundImageProps,
  BackgroundSizeProps,
  BackgroundPositionProps,
  BackgroundRepeatProps
} from 'styled-system';
import { filter } from 'src/helpers';
import { PositionBox, PositionBoxProps } from './Box';

export type BgImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'size' | 'width' | 'height'> &
  PositionBoxProps &
  BackgroundImageProps &
  BackgroundSizeProps &
  BackgroundPositionProps &
  BackgroundRepeatProps & {
    filter?: string;
  };

export const BgImage = styled(PositionBox)<BgImageProps>`
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-image: ${props => props.src && 'url(' + props.src + ')'};
  ${backgroundImage};
  ${backgroundPosition};
  ${backgroundRepeat};
  ${backgroundSize};
  ${filter};
`;
